import React, { useEffect } from 'react';
import {
    useDispatch,
    useSelector
} from "../../imports/generalImport";
import {
    Container,
    Card,
    CardHeader,
    CardContent,
    Typography,
    Box,
    Divider
} from "../../imports/muiImport";
import { Helmet } from 'react-helmet-async';
import OrderStatusChip from '../../pages/profileDashboard/statement/OrderStatusChip';
import { dateChanger } from '../../shared/extra';
import moment from 'moment';
import {
    dateSlashFormant,
    getLastMonthDate
} from '../../shared/dateFunction';
import { onFetchUserStatement } from '../../store/userStatement/action';
import TableFilter from "../../components/tableFilter";

const momentDate = moment();

const initialData = {
    search: null,
    filterBy: null,
    date: {
        from: getLastMonthDate(),
        to: dateSlashFormant(momentDate)
    },
    pagination: {
        sortBy: 'id',
        descending: true,
        page: 1,
        rowsPerPage: 999999,
        rowsNumber: 0
    },
    status: 0
};

function MobileUserTransactions() {
    const UserStatementData = useSelector((state) => state?.UserStatement?.allData);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(onFetchUserStatement(initialData));
    }, [dispatch]);

    return (
        <Container maxWidth="md" sx={{ pt: 3, pb: 5, bgcolor: "white.main" }}>
            <Helmet>
                <title>Profile Statement - 99gift.in</title>
                <meta property="og:title" content="Profile Statement - 99gift.in" />
            </Helmet>

            <Box sx={{ mb: 2 }}>
                <TableFilter initialData={initialData} reducer={onFetchUserStatement} />
            </Box>
            {UserStatementData?.length === 0 ? (
                <Box
                    sx={{
                        textAlign: 'center',
                        mt: 5,
                        mb: 8,
                        px: 2,
                    }}
                >
                    <Typography
                        variant="h6"
                        color="text.secondary"
                        fontWeight={500}
                        gutterBottom
                    >
                        No transactions found
                    </Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                    >
                        There are no statements available for the selected filters or from the last 1 month.
                    </Typography>
                </Box>
            ) : (
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',
                            sm: '1fr 1fr',
                            md: '1fr 1fr',
                            lg: '1fr 1fr 1fr',
                        },
                        gap: 2,
                    }}
                >
                    {UserStatementData?.map((item) => (
                        <Card
                            key={`statement-${item?.id}`}
                            sx={{
                                borderRadius: 2,
                                boxShadow: 1,
                                border: '1px solid',
                                borderColor: 'grey.300',
                                display: 'flex',
                                flexDirection: 'column',
                                height: '100%',
                            }}
                        >
                            {/* Date Header */}
                            <CardHeader
                                sx={{
                                    p: 1.5,
                                    backgroundColor: "lightSecondary.main",
                                    textAlign: 'center',
                                }}
                                title={
                                    <Typography variant="subtitle2" color="primary" fontWeight={500}>
                                        {dateChanger(item?.created_at)}
                                    </Typography>
                                }
                            />

                            {/* Order Details */}
                            <CardContent sx={{ px: 2, py: 1.5 }}>
                                <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography variant="body2" fontWeight={500}>Order</Typography>
                                    <Typography variant="body2" color="secondary.main">{item?.id}</Typography>
                                </Box>

                                <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography variant="body2" fontWeight={500}>Remark</Typography>
                                    <Typography variant="body2" color="primary.main">{item?.remark}</Typography>
                                </Box>

                                <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography variant="body2" fontWeight={500}>Description</Typography>
                                    <Typography variant="body2" color="primary.main">{item?.description}</Typography>
                                </Box>

                                <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography variant="body2" fontWeight={500}>Amount</Typography>
                                    <Typography variant="body2" color="success.main">₹{item?.amount}</Typography>
                                </Box>

                                <Divider sx={{ my: 1, borderStyle: 'dashed', borderColor: "dark.main" }} />

                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography variant="body2" fontWeight={600} color="primary.main">
                                        Status
                                    </Typography>
                                    <OrderStatusChip value={item?.status?.status} />
                                </Box>
                            </CardContent>
                        </Card>
                    ))}
                </Box>
            )}
        </Container>
    );
}

export default MobileUserTransactions;
